import React, { useState, useEffect, useRef } from "react";
import dayjs from "dayjs";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import loader from "../assets/loader.svg";
import AxiosInstance from "../utils/axiosInstance";
import ShowFavoritesModal from "./Model/showFavoratiesModel";
const CalendarComponent = () => {
  const today = dayjs();
  const [viewDate, setViewDate] = useState(dayjs().startOf("month"));
  const [eventsByDate, setEventsByDate] = useState({});
  const [modalData, setModalData] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [globalLoading, setGlobalLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [selectedState, setSelectedState] = useState();
  const [StateListFromLocalStorage, setStateListFromLocalStorage] = useState(
    []
  );
  const [data, setData] = useState([]);
  const [APICall, setAPICAll] = useState(false);
  const [storedState, setstoredState] = useState(
    JSON.parse(localStorage.getItem("selectedState"))
  );
  const isInitialRender = useRef(true);

  const transformData = (items) =>
    items.map(({ id, name }) => ({
      value: id,
      label: name,
    }));

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("loggedInUserInfo") || "[]");
    const transformedData = transformData(data?.state || []);
    setStateListFromLocalStorage(transformedData);

    if (!storedState && transformedData.length > 0) {
      localStorage.setItem("selectedState", JSON.stringify(transformedData[0]));
      setSelectedState(transformedData[0]);
    }
  }, []);
  const handleModalClose = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (storedState && StateListFromLocalStorage.length > 0) {
      const selectedOption = StateListFromLocalStorage.find(
        (option) => option.label === storedState.label
      );
      setSelectedState(selectedOption || null);
    }
  }, [StateListFromLocalStorage]);

  useEffect(() => {
    if (!isInitialRender.current && selectedState) {
      localStorage.setItem("selectedState", JSON.stringify(selectedState));
    }
  }, [selectedState]);

  useEffect(() => {
    if (!selectedState) return;
    getAllFavorite(selectedState);
  }, [selectedState]);

  const getAllFavorite = (selectedState) => {
    AxiosInstance.get(
      `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_GET_ALL_FAVORITES}?state_id=${selectedState.value}`
    )
      .then((response) => {
        const data = response.data?.data;
        const map = {};
        const allEvents = [...(data.dot || []), ...(data.project || [])];

        allEvents.forEach((event) => {
          const dateKey = dayjs(
            event.estimated_end_date || event.lettingdate || dayjs()
          ).format("YYYY-MM-DD");

          if (!map[dateKey]) map[dateKey] = [];
          map[dateKey].push(event);
        });

        setEventsByDate(map);
    
        setGlobalLoading(false);
      })
      .catch((error) => {
        console.error(error?.message);
        setGlobalLoading(false);
      });
  };

  useEffect(() => {
    const state = selectedState || storedState;
    if (APICall) {
      getAllFavorite(state);
    }
  }, [APICall]);

  const generateCalendar = () => {
    const daysInMonth = viewDate.daysInMonth();
    const startDay = viewDate.startOf("month").day();
    const totalCells = Math.ceil((startDay + daysInMonth) / 7) * 7;
    const days = [];

    for (let i = 0; i < totalCells; i++) {
      const dayNumber = i - startDay + 1;
      const isCurrentMonth = i >= startDay && dayNumber <= daysInMonth;
      const fullDate = isCurrentMonth ? viewDate.date(dayNumber) : null;

      days.push({
        date: isCurrentMonth ? dayNumber : "",
        isCurrentMonth,
        fullDate,
        dayIndex: i % 7,
      });
    }

    return days;
  };

  const handleNextMonth = () => setViewDate(viewDate.add(1, "month"));
  const handlePrevMonth = () => {
    const prevMonth = viewDate.subtract(1, "month");
    const canGoBack =
      prevMonth.month() >= today.month() || prevMonth.year() > today.year();
    if (canGoBack) setViewDate(prevMonth);
  };

  const calendarDays = generateCalendar();
  const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const rows = [];
  for (let i = 0; i < calendarDays.length; i += 7) {
    rows.push(calendarDays.slice(i, i + 7));
  }

  const handleApiCall = () => {
    setAPICAll(true);
    setShowModal(false);
    setModalData(null);
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <button
          className="btn btn-outline-primary"
          onClick={handlePrevMonth}
          disabled={
            viewDate.month() === today.month() &&
            viewDate.year() === today.year()
          }
        >
          Prev
        </button>
        <h4 className="text-primary fw-bold mb-0">
          {viewDate.format("MMMM YYYY")}
        </h4>
        <button className="btn btn-outline-primary" onClick={handleNextMonth}>
          Next
        </button>
      </div>

      <div className="row d-none d-sm-flex p-1 bg-primary text-white">
        {dayNames.map((dayName, idx) => (
          <div key={idx} className="col-sm p-1 text-center">
            {dayName}
          </div>
        ))}
      </div>

      <div className="position-relative">
        {globalLoading && (
          <div
            className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
            style={{ backgroundColor: "rgba(255,255,255,0.7)", zIndex: 10 }}
          >
            <img src={loader} alt="Loading..." width="60" />
          </div>
        )}

        {rows.map((week, weekIndex) => (
          <div
            key={weekIndex}
            className="row border border-right-0 border-bottom-0"
          >
            {week.map((day, dayIndex) => {
              const dateKey = day.fullDate?.format("YYYY-MM-DD");
              const dayEvents = eventsByDate[dateKey] || [];
              const isToday = day.fullDate?.isSame(today, "day");
              const isPast = day.fullDate?.isBefore(today, "day");

              let dayClass =
                "day col-sm p-2 border border-left-0 border-top-0 text-truncate";
              if (!day.isCurrentMonth || isPast) {
                dayClass += " bg-light text-dark fw-bold";
              } else if (isToday) {
                dayClass += " fw-bold";
              }

              return (
                <div key={dayIndex} className={dayClass}>
                  <h5 className="row align-items-center">
                    <span
                      className={`date col-1 ${isToday ? "today-circle" : ""}`}
                    >
                      {day.date}
                    </span>
                    <small className="col d-sm-none text-center text-muted">
                      {day.date ? dayNames[day.dayIndex] : ""}
                    </small>
                    <span className="col-1"></span>
                  </h5>

                  {dayEvents.length > 0 ? (
                    <>
                      {dayEvents.slice(0, 2).map((ev, i) => (
                        <div
                          key={i}
                          className="event d-block p-1 pl-2 pr-2 mb-1 rounded text-truncate text-decoration-none small bg-secondary text-white text-center"
                          role="button"
                          onClick={() => {
                            setModalType(ev.call_order ? "DOT" : "Project");
                            setData(ev);
                            setShowModal(true);
                          }}
                        >
                          {ev.call_order || ev.project_title}
                        </div>
                      ))}
                      {dayEvents.length > 2 && (
                        <div
                          className="badge bg-secondary text-white w-100 "
                          role="button"
                          onClick={() =>
                            setModalData({ events: dayEvents, date: dateKey })
                          }
                        >
                          +{dayEvents.length - 2} more
                        </div>
                      )}
                    </>
                  ) : day.isCurrentMonth && !isPast ? (
                    <p className="small text-muted">No events</p>
                  ) : null}
                </div>
              );
            })}
          </div>
        ))}
      </div>

      {/* Modal for Full Day Events */}
      <Modal show={!!modalData} onHide={() => setModalData(null)} size="md">
        <Modal.Header closeButton>
          <Modal.Title>
            Events for{" "}
            {modalData?.date && dayjs(modalData.date).format("MMMM D, YYYY")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalData?.events?.map((ev, i) => (
            <div
              key={i}
              className="mb-2 p-2 border rounded bg-light"
              role="button"
              onClick={() => {
                setModalType(ev.call_order ? "DOT" : "Project");
                setData(ev);
                setShowModal(true);
              }}
            >
              <strong>{ev.name || ev.project_title}</strong> —{" "}
              {ev.name ? "DOT" : ev.page_type}
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModalData(null)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for Individual Event */}
      {selectedEvent && (
        <Modal show onHide={() => setSelectedEvent(null)}>
          <Modal.Header closeButton>
            <Modal.Title>
              {selectedEvent.name || selectedEvent.project_title} (
              {selectedEvent.type || selectedEvent.page_type})
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedEvent.type === "DOT" ? (
              <>
                <p>
                  <strong>Call Order:</strong> {selectedEvent.call_order}
                </p>
                <p>
                  <strong>Call ID:</strong> {selectedEvent.callid}
                </p>
                <p>
                  <strong>Description:</strong> {selectedEvent.Ldescription}
                </p>
              </>
            ) : (
              <>
                <p>
                  <strong>Project Title:</strong> {selectedEvent.project_title}
                </p>
                <p>
                  <strong>Description:</strong>{" "}
                  {selectedEvent.project_description}
                </p>
                <p>
                  <strong>Project Type:</strong> {selectedEvent.page_type}
                </p>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setSelectedEvent(null)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <style>
        {`
    .today-circle {
      background-color:blue;
      color: white;
      border-radius: 50%;
      padding: 4px 4px;
      display: inline-block;
      min-width: 32px;
      text-align: center;
      margin: 0 8px;
    }
  `}

        {showModal && (
          <ShowFavoritesModal
            open={showModal}
            type={modalType}
            handleModalClose={handleModalClose}
            data={data}
            handleAPIcall={handleApiCall}
          />
        )}
      </style>
    </div>
  );
};

export default CalendarComponent;
